import React, { useEffect, useState } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { Container} from 'react-bootstrap';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { app } from '../../credenciales.js';
import FloatingBtn from '../../components/FloatingBtn/FloatingBtn.jsx';
import Calendar from '../../components/Calendar/Calendar.jsx';

const HomeAlumno = () => {
  const db = getFirestore(app);
  const [activities, setActivities] = useState();

  useEffect(() => {
    const fetchActivities = async () => {
      const actividadesRef = collection(db, "actividades");
      const snapshot = await getDocs(actividadesRef);
      const allDates = [];
      const activitiesData = {};

      snapshot.forEach((doc) => {
        const data = doc.data();
        if (data.fechas) {
          data.fechas.forEach((fecha) => {
            if (!activitiesData[fecha.fecha]) {
              activitiesData[fecha.fecha] = [];
            }
            activitiesData[fecha.fecha].push({ id: doc.id, name: data.nombre, time: fecha.fecha, hora: data.hora });
          });
        }
      });

      //setActivityDates(allDates);
      setActivities(activitiesData);
    };

    fetchActivities();
  }, [activities]);

  return (
    <Container className='py-4'>
      <h1 className='titles'>Calendario de Actividades</h1>

      <div className="calendar-wrapper">
        {activities && <Calendar activities={activities} isAdmin={false} />}
      </div>
      {/* <FloatingBtn /> */}
    </Container>
  );
};

export default HomeAlumno;